import axiosInstance from '@/services/axiosInstance'

async function logout () {
  const req = {
    url: 'api/login/logOut',
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    },
  }

  const res = await axiosInstance(req)
  return res.data
}

export { logout }
